<template>
  <div class="container">
      <NavbarSimple :leftText="$t('investPage.productDetails')"></NavbarSimple>
      <div class="block1">
          <div class="block1-1">
              <span>USDT</span>
              <span>{{$t("common.accountAvailableBalance")}}</span>
              <div>
                  <span>{{availableBalance}}</span>
                  <span>USDT</span>
              </div>
          </div>
          <img :src="product.productImage" style="border-radius:2rem;">
      </div>
      <div class="block2">
          <div>
              <span>{{$t("productDetailsPage.startingAmount")}}</span>
              <span>{{product.startingAmount}} USDT</span>
          </div>
          <div>
              <span>{{$t("productDetailsPage.maxInvestmentAmount")}}</span>
              <span>{{product.maxInvestmentAmount}} USDT</span>
          </div>
          <div>
              <span>{{$t("investPage.cycle")}}</span>
              <span>{{product.cycle}} {{$t("investPage.day")}}</span>
          </div>
          <div>
              <span>{{$t("productDetailsPage.dailyInterestRate")}}</span>
              <span>{{product.dailyInterestRate * 100}}%</span>
          </div>
          <div>
              <span>{{$t("productDetailsPage.investableQuantity")}}</span>
              <span>{{product.investableQuantity}}</span>
          </div>
      </div>
      <div class="block3">
          <div>
              <span>{{$t("productDetailsPage.investmentAmount")}}</span>
              <input type="number" v-model="formObj.amount" min="0">
          </div>
          <div class="calc">
              <span>{{`${formObj.amount}+(${formObj.amount}x${product.dailyInterestRate}x${product.cycle})=`}}{{formObj.amount * 1 + (formObj.amount * product.dailyInterestRate * product.cycle)}}</span>
          </div>
          <van-button round color="#4A3933" block @click="submit">{{ $t("productDetailsPage.participateInInvestment") }}</van-button>
      </div>
  </div>
</template>

<script>
import NavbarSimple from '@/components/NavbarSimple.vue'
export default {
    name: 'productDetails',
    components: {
        NavbarSimple,
    },
    data() {
        return {
            availableBalance: 0,
            product: {},
            formObj: {
                amount: 0
            }
        }
    },
    mounted() {
        this.token = localStorage.getItem('token');
        this._fetch();
    },
    methods: {
        _fetch() {
            this.apiV1({
                method: 'get',
                url: '/financialProduct/' + this.$route.query.id,
                headers: {'Authorization': this.token}
            }).then(response => {
                const { success, data } = response.data;
                if (success) {
                    this.availableBalance = data.availableBalance;
                    this.product = data.product;
                }
            })
        },
        submit() {
            if (this.formObj.amount) {
                this.apiV1({
                    method: 'post',
                    url: '/financialProduct/invest',
                    data: {
                        id: this.$route.query.id,
                        ...this.formObj
                    },
                    headers: {'Authorization': this.token}
                }).then(response => {
                    const { success } = response.data;
                    if (success) {
                        this.$toast.success(this.$t("common.submitted"));
                        this.$router.push('/investedList');
                    }
                })
            } else {
                if (!this.formObj.amount) {
                     this.$notify({ type: 'danger', message: 'Investment amount required.' });
                    return
                }
            }
        }
    }
}
</script>

<style scoped lang="less">
.block1, .block2, .block3 {
    margin: 0 6.4rem 4rem;
    padding: 3.2rem;
    border-radius: 5.333rem;
    background-color: @app-theme-color4;
    border: 0.667rem solid @app-theme-color1;
    display: flex;
}
.block1 {
    justify-content: space-between;
    .block1-1 {
        display: flex;
        flex-direction: column;
        >div {
            display: flex;
            justify-content: space-between;
            margin-top: 3.2rem;
            font-weight: bold;
        }
    }
    img {
        // width: 23.2rem;
        height: 21.067rem;
        margin-left: 3.2rem;
    }
}
.block2 {
    flex-direction: column;
    >div {
        display: flex;
        justify-content: space-between;
        span:nth-child(2) {
            font-weight: bold;
        }
    }
    div + div {
        margin-top: 3.2rem;
    }
}
.block3 {
    flex-direction: column;
    .calc {
        text-align: right;
        margin: 3.2rem 0;
    }
}
</style>